import DemoPageWrapper from "../../utils/DemoPageWrapper";
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "type",
      description: "按钮类型 ",
      type: "String",
      default: "btn",
      available: "btn/iconBtn/text"
    },
    {
      prop: "iconClass",
      description: "图标字体,当设置type为iconBtn有效",
      type: "String",
      required: true
    },
    {
      prop: "theme",
      description:
        "btn有4种theme:1、2、3、4;iconBtn有2种theme:1、2;text无theme,",
      type: "String",
      default: "1"
    },
    {
      prop: "disabled",
      description: "是否禁用",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "loading",
      description: "是否加载,带icon按钮与文字按钮无加载中",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "size",
      description: "尺寸",
      type: "String",
      available: "mini/small/default/middle/large",
      default: "default"
    },
    {
      prop: "width",
      description: "宽度大小，text-button根据文字内容自适应宽度",
      type: "String",
      default: "100"
    },
    {
      prop: "border",
      description: "按钮是否拥有边框",
      type: "Boolean",
      default: "false"
    }
  ],
  events: [],
  methods: [],
  slots: []
};

export default DemoPageWrapper(Demo, DemoSource, config);
